<template>
<div id="careers-page">
    <div class="jumbotron jumbotron-big text-center" style="background: url(assets/crealco/background-people-team-ujv.jpg) !important; background-size: cover !important; background-position: left center !important;">

		<div class="white position-absolute top-0 row h-100 w-100 justify-content-center align-items-center text-center margin-right-left-0">

			<div class="jumbo-info">

				<h1 class="text-uppercase font-xl white text-shadow">Design Unforgettable Vacations<br> By Becoming A World Class <br>Luxury Travel Advisor</h1> 

			</div>

		</div> 

    	<!--<div class="controllers-cont">

    		<div class="next-section-anchor"><a><i class="material-icons">arrow_downward</i></a>

    		</div>

    	</div>-->

    </div>



    <div class="container pb-1">

    	<h2 class="bd-title section-title default-letter-spacing font-lg text-center font-weight-normal">Join us and become a part one of the world's leading providers of luxury travel.</h2>

        <h2 class="bd-title section-title default-letter-spacing text-uppercase font-md text-center font-weight-bold" style="margin-bottom: 1rem;">Our Core Values</h2>

    	<div class="row text-center">    		

    		<div class="col-md-4 mb-2">

    			<div class="py-4 rounded-xl" style="">

    				<img src="assets/crealco/ico-employees-happiness.png" style="max-width: 130px; width: 100%" class="mx-auto mb-3">

    				<p>Our Most Important Responsibility: Our Employees Happiness</p>

    			</div>    			

    		</div>	

    		<div class="col-md-4 mb-2">

                <div class="py-4 rounded-xl" style="">

                    <img src="assets/crealco/ico-client-satisfaction.png" style="max-width: 130px; width: 100%" class="mx-auto mb-3">

                    <p>We are Obsessed With Client Satisfaction and Service</p>

                </div>              

            </div>  

            <div class="col-md-4 mb-2">

                <div class="py-4 rounded-xl" style="">

                    <img src="assets/crealco/ico-business-partners.png" style="max-width: 130px; width: 100%" class="mx-auto mb-3">

                    <p>Our Business Partners Relationships</p>

                </div>              

            </div>  

    	</div>

    </div>

    <div style="background: #0071bc;">

    	<section class="container pb-4 pt-1">

            <h2 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md white text-center d-block" style="margin-bottom: 1.5rem;">Benefits</h2>

    		<img src="assets/crealco/benefits.png" style="width: 100%" class="mx-auto mb-4">

    	</section>

    </div>

    <div style="background: #202020;">

        <section class="container pb-4 pt-1 text-center pb-4">

            <h2 class="bd-title section-title default-letter-spacing text-uppercase font-weight-bold font-md white text-center d-block" style="margin-bottom: 1.5rem;">Job Opportunities</h2>

            <img src="assets/crealco/job-career.webp" style="width: 100%; max-width: 300px" class="mx-auto mb-4 d-block">

            <a href="https://ultimatejetvacations.bamboohr.com/jobs/view.php?id=36&source=aWQ9MjU%3D" target="_blank" class="btn btn-primary bg-blue-500 mx-auto text-gray-50 font-bold py-3 px-4 rounded-full mb-4 hover:bg-opacity-0 border-2 border-blue-500 hover:text-blue-500" style="text-decoration: none; transition: 0.5s ease all">Apply Now</a><br><br>

        </section>

    </div>



      <div class="container pb-3 pt-4 text-center">

       <img src="assets/crealco/ico-instagram.png" style="width: 100%; max-width: 38px" class="mx-auto mb-4 mt-2">

        <h2 class="bd-title section-title default-letter-spacing text-uppercase font-md text-center font-weight-bold" style="margin-bottom: 1.5rem; margin-top: 1.5rem;">Our Latest Experiences</h2>

        <a href="https://www.instagram.com/ultimatejetvacations/" target="_blank" class="mx-auto mb-4 mt-2"><img src="assets/crealco/instagram-posts-ujv.png" style="width: 100%; max-width: 1100px" class=""></a>

        <img src="assets/crealco/ultimate-jet-vacations-logo-dark.svg" style="width: 100%; max-width: 350px" class="mx-auto mb-4 mt-4">

    </div>
</div>  
</template>

<script>

    export default {
        components: { },
    }
</script>
